var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-list',_vm._l((_vm.cards),function(card,index){return _c('component-wrapper',{key:index,attrs:{"config":card}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }